<template>
  <div class="service-wrapper">
    <!-- 触发按钮 -->
    <div class="service-trigger hbox" @mouseenter="show = true" @mouseleave="show = false">
      <a-badge :count="chat_unread" :dot="true" :offset="[0, 0]">
        <div class="trigger-text">
          <i class="iconfont icon-kefufuwu"></i>
          <span>{{ $t('_db._zskf') }}</span>
        </div>
      </a-badge>
    </div>

    <!-- 下拉面板 -->
    <div class="service-panel" v-show="show" @mouseenter="show = true" @mouseleave="show = false">
      <div class="service-box">
        <!-- 在线客服 -->

        <div class="panel-item" @click="onService">
          <div class="xdiv">
            <a-badge :count="chat_unread" :offset="[0, 0]">
              <i class="iconfont icon-kefu" style="color: #b0bcc8"></i>
            </a-badge>
            <span>{{ $t('_db._zsry') }}</span>
          </div>
          <i class="iconfont icon-youjiantou"></i>
        </div>

        <!-- WhatsApp -->
        <a v-if="sp_info.whatsapp" :href="'https://wa.me/' + sp_info.whatsapp" target="_blank" class="panel-item">
          <div class="xdiv">
            <i class="iconfont icon-whatsapp"></i>
            <span>WhatsApp</span>
          </div>
          <i class="iconfont icon-youjiantou"></i>
        </a>

        <!-- Telegram -->
        <a v-if="sp_info.telegram" :href="'https://t.me/' + sp_info.telegram" target="_blank" class="panel-item">
          <div class="xdiv">
            <i class="iconfont icon-telegram"></i>
            <span>Telegram</span>
          </div>
          <i class="iconfont icon-youjiantou"></i>
        </a>

        <!-- Line -->
        <div v-if="sp_info.line" class="panel-item" @click="goLink(sp_info.line)">
          <div class="xdiv">
            <i class="iconfont icon-line"></i>
            <span>Line</span>
          </div>
          <i class="iconfont icon-youjiantou"></i>
        </div>

        <!-- Line QR 码 -->
        <div v-else-if="sp_info.line_qrcode" class="panel-item qr-item" @mouseenter="showQr = true" @mouseleave="showQr = false">
          <div class="xdiv">
            <i class="iconfont icon-line"></i>
            <span>Line</span>
          </div>
          <i class="fas fa-qrcode"></i>
          <!-- QR 弹窗 -->
          <div class="qr-popup" v-show="showQr">
            <img :src="sp_info.line_qrcode + '?t=' + Date.now()" alt="Line QR" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServiceVue',
  props: {
    chat_unread: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      sp_info: {},
      show: false,
      showQr: false
    }
  },
  created() {
    const info = this.$common.getInfo()
    if (info?.agent) {
      this.sp_info = info.agent
    }
  },
  methods: {
    onService() {
      this.$router.push({ name: 'service' })
      this.show = false
    },
    goLink(url) {
      if (url) {
        window.open(url, '_blank')
        this.show = false
      }
    }
  }
}
</script>

<style scoped>
/* ===== 容器 ===== */
.service-wrapper {
  position: relative;
  display: inline-block;
}

/* ===== 触发按钮 ===== */
.service-trigger {
  padding: 4px 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.25s;
}

.service-trigger:hover {
  background: rgba(255, 255, 255, 0.06);
}

.trigger-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  color: #8a949f;
  font-size: 12px;
  transition: color 0.25s;
}

.service-trigger:hover .trigger-text {
  color: #e8edf2;
}

.trigger-text i {
  font-size: 20px;
  color: #e8edf2;
}

.trigger-text span {
  font-size: 14px;
}

/* ===== 下拉面板 ===== */
.service-panel {
  position: absolute;
  top: calc(100% + 0px);
  right: 0;
  z-index: 100;
  animation: dropIn 0.2s ease;
  padding-top: 13px;
}

.service-box {
  min-width: 200px;
  background: #141a20;
  border-radius: 14px;
  border: 1px solid #1e262e;
  box-shadow: 0 16px 64px rgba(0, 0, 0, 0.7);
  padding: 8px 0;
}

/* ===== 菜单项 ===== */
.panel-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  color: #b0bcc8;
  font-size: 14px;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
  position: relative;
}

.panel-item:hover {
  background: rgba(255, 255, 255, 0.05);
  color: #e8edf2;
}

.panel-item i:first-child {
  font-size: 18px;
  width: 24px;
  text-align: center;
  flex-shrink: 0;
}

.panel-item .xdiv {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
}

.panel-item .arrow {
  color: #3a4652;
  font-size: 12px;
  margin-left: auto;
}

.panel-item:hover .arrow {
  color: #5a6672;
}

/* ===== 特殊：QR 码项 ===== */
.qr-item {
  position: relative;
}

.qr-popup {
  position: absolute;
  bottom: calc(100% + 12px);
  right: 0;
  width: 160px;
  height: 160px;
  background: #0f1419;
  border-radius: 12px;
  border: 1px solid #1e262e;
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.6);
  padding: 8px;
  animation: dropIn 0.2s ease;
}

.qr-popup img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 6px;
}

/* ===== 入场动画 ===== */
@keyframes dropIn {
  from {
    opacity: 0;
    transform: translateY(-6px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* ===== 响应式 ===== */
@media (max-width: 768px) {
  .service-trigger {
    padding: 2px 6px;
  }
  .trigger-text i {
    font-size: 16px;
  }
  .trigger-text span {
    font-size: 14px;
  }
  .service-panel {
    min-width: 170px;
    right: -8px;
  }
  .panel-item {
    padding: 8px 14px;
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .service-panel {
    min-width: 160px;
    right: -12px;
  }
  .panel-item {
    padding: 8px 12px;
    font-size: 12px;
  }
  .panel-item i:first-child {
    font-size: 16px;
    width: 20px;
  }
  .qr-popup {
    width: 130px;
    height: 130px;
    right: -10px;
  }
}

.iconfont {
  font-size: 24px !important;
}

.hbox {
  height: 46px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
